import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import { useApi } from '~/lib/api/useApi';
import { IApiFontAwesomeGetSessionTokenResponseBody } from '../ProvidersApi.types';

export type IUseFontAwesomeSessionTokenQueryValues = Record<string, never>;

export const fontAwesomeSessionTokenQueryKeyFactory: IQueryKeyFactory = () =>
  ['fontAwesomeSessionToken'] as const;

export const useFontAwesomeSessionTokenQuery = (
  options?: UseQueryOptions<
    IApiFontAwesomeGetSessionTokenResponseBody,
    ApiError
  >,
): UseQueryResult<IApiFontAwesomeGetSessionTokenResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: fontAwesomeSessionTokenQueryKeyFactory(),
    queryFn: () => api.providers.getFontAwesomeSessionToken(),
    ...options,
  });
};
